import { Alert, Box, Button, Modal, styled, Typography } from "@mui/material";

export const Styled = {
    Modal: styled(Modal)`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    Content: styled(Box)`
        overflow-x: auto;
        background-color: ${props => props.theme.palette.secondary.main};
        border: 2px solid ${props => props.theme.palette.secondary.light};
        border-radius: 24px;
        display: flex;
        flex-direction: column;
        gap: 25px;

        ${props => props.theme.breakpoints.down("lg")} {
            width: 65vw;
        }
        ${props => props.theme.breakpoints.down("md")} {
            width: 85vw;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 95vw;
        }
    `,
    Header: styled("div")`
        display: flex;
        justify-content: space-between;
        padding: 15px 32px;
        background-color: ${props => props.theme.palette.secondary.dark};
        & .MuiTypography-root {
            color: #fff;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
        }
    `,
    QRBody: styled("div")`
        padding: 0px 32px 24px 32px;
        display: flex;
        justify-content: space-evenly;
        gap: 50px;

        ${props => props.theme.breakpoints.down("md")} {
            gap: 25px;
        }

        ${props => props.theme.breakpoints.down("sm")} {
            flex-direction: column;
            align-items: center;
            gap: 50px;
            padding: 0px 5px 10px 5px;
        }
    `,
    Body: styled("div")`
        padding: 0px 32px 24px 32px;
        display: flex;
        flex-direction: column;
        ${props => props.theme.breakpoints.down("sm")} {
            padding: 0px 5px 10px 5px;
        }
    `,
    CloseButton: styled(Button)`
        background: unset;
        min-width: unset;
        padding: unset;
        :hover {
            background: unset;
        }
    `,

    QRSettings: styled(Box)`
        display: flex;
        flex-direction: column;
        gap: 24px;
        width: 300px;
    `,
    QRWrapper: styled(Box)`
        width: 225px;
        height: 225px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 202.5px;
            height: 202.5px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 180px;
            height: 180px;
        }
    `,
    ComplianceAlert: styled(Alert)`
        font-size: 10px;
        margin-top: 20px;
        padding: 0px 10px;

        width: 225px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 202.5px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 180px;
        }
    `,
    QRCanvas: styled("canvas")`
        width: 225px;
        height: 225px;
        ${props => props.theme.breakpoints.down("md")} {
            height: 202.5px;
            height: 202.5px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 180px;
            height: 180px;
        }
    `,
    QRSvg: styled(Box)`
        width: 202.5px;
        height: 202.5px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 182.25px;
            height: 182.25px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 162px;
            height: 162px;
        }
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    `,
    CardList: styled("ul")`
        display: flex;
        align-items: center;
        overflow-x: auto;
        margin: 20px 0px;
        ::-webkit-scrollbar {
            display: none;
        }
        scrollbar-width: none;
        -ms-overflow-style: none;
        ${props => props.theme.breakpoints.down("sm")} {
            flex-direction: column;
            overflow-x: none;
            overflow-y: auto;
            max-height: 60vh;
        }
    `,
    CardListItem: styled("li")`
        margin: 0px 10px;
        border-radius: 20px;
        padding: 10px;
        cursor: pointer;
        transition: background-color 0.1s linear;
        background-color: transparent;
        :hover {
            background-color: ${props => props.theme.palette.secondary.light};
        }
    `,
    CardBackground: styled("img")`
        border-radius: 10px;
        width: 300px;
        height: 150px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 270px;
            height: 135px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 240px;
            height: 120px;
        }
    `,
    CardLogo: styled("img")`
        position: absolute;
        z-index: 9;
        right: 5%;
        bottom: 10%;
        width: 70px;
        height: 45px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 63px;
            height: 40.5px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 56px;
            height: 36px;
        }
    `,
    DippiLogo: styled("img")`
        position: absolute;
        z-index: 9;
        left: 5%;
        bottom: 10%;
        width: 70px;
        height: 45px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 63px;
            height: 40.5px;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 56px;
            height: 36px;
        }
    `,
    PublicTitle: styled(Typography)`
        position: absolute;
        width: 95%;
        text-align: center;
        z-index: 9;
        top: 5%;
        left: 50%;
        transform: translateX(-50%);
        text-transform: uppercase;
    `,

    BrandList: styled("ul")`
        display: flex;
        align-items: center;
        margin: 20px 0px;
    `,
    BrandListItem: styled("li")`
        border-radius: 8px;
        height: 150px;
        width: 125px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0px 8px;
        cursor: pointer;
        transition: background-color 0.1s linear;
        background-color: transparent;
        :hover {
            background-color: ${props => props.theme.palette.secondary.light};
        }
        border: 2px solid ${props => props.theme.palette.secondary.light};
    `,
    BrandLogo: styled("img")`
        width: 70px;
        margin-bottom: 10px;
    `,
    BrandLogoPlaceholder: styled("div")`
        min-height: 70px;
        min-width: 70px;
        border-radius: 37.5px;
        margin-bottom: 10px;
        background-color: gray;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};
